'use strict'

const deriveMethods = (adt, definitions) => {
  Object.keys(definitions).forEach(name => {
    adt.variants.forEach(variant => {
      variant.prototype[name] = definitions[name][variant.tag]
    })
  })
}

module.exports = deriveMethods



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/adt/deriveMethods.js